export default {"src":"/_next/static/media/mastercardLogo.94429c39.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};